import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTextField,
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function (_, slot) {
                return {
                  key: slot,
                  fn: function (scope) {
                    return [_vm._t(slot, null, null, scope)]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        "VTextField",
        _vm.finalAttr,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l(_vm.$slots, function (_, slot) {
        return _vm._t(slot, null, { slot: slot })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }